import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  value?: string;
  placeholder?: string;
  maxlength?: string | number;
  fitContainer?: boolean;
  error?: string | null;
  disabled?: boolean;
  textareaClass?: string;
}

interface Emits {
  (e: 'input', data: Props['value']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiTextarea',
  props: {
    value: { default: undefined },
    placeholder: { default: undefined },
    maxlength: { default: undefined },
    fitContainer: { type: Boolean, default: false },
    error: { default: null },
    disabled: { type: Boolean, default: false },
    textareaClass: { default: '' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, placeholder: string, maxlength: string | number, fitContainer: boolean, error: string | null, disabled: boolean, textareaClass: string };





const valueLocal = computed<any>({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

return { __sfc: true,props, emit, valueLocal }
}

})